/**
 * routers/knowledge.js — Минутын мэдлэг (м-мэдлэг) модулийн замууд
 *
 * Цэс (root):
 *   /knowledge/register  — өнөөдрийн мэдлэг + (ХАБЭА хэлтэст) мэдлэгийн сан,
 *                          7 хоногийн хуваарь
 *   /knowledge/dashboard — биелэлтийн хяналт (ХАБЭА хэлтэс)
 */
import React from "react";
import _ from "lodash";
import { Routes, Route } from "react-router-dom";

import { lazyRetry } from "src/utils/lazyRetry";

/* ── СТАТИК: ажилтны ӨДӨР ТУТМЫН зам ───────────────────────────────────
   Эдгээр нь chunk татдаггүй тул сүлжээ, deploy, кэшийн ямар ч байдалд
   эвдэрч чадахгүй (router.js-ийн архитектурын зарчим).
     register  — «өнөөдрийн мэдлэг» (өдөрт 1 асуулт) ажилтан бүрд
     my        — миний түүх
     ask       — журмаас асуух
     qr        — техник дээрх наалт (нэвтрэлтгүй ч ажиллана)           */
import KnowledgeRegister from "src/pages/knowledge/register";
import KnowledgeMy from "src/pages/knowledge/my";
// QR суваг — техник дээрх наалтаас «санамж видео» (Visio page4)
import KnowledgeQrView from "src/pages/knowledge/qr";
import KnowledgeAsk from "src/pages/knowledge/ask";

/* ── LAZY: МЭРГЭЖИЛТНИЙ хуудсууд → "hse" chunk (2026-10-29) ───────────
   ⚠ ЯАГААД: эдгээр 5 хуудас 5 927 мөр эзэлдэг бөгөөд СТАТИК байсан тул
     `main.js` дотор орж, ажилтан «өнөөдрийн мэдлэг» нээхэд ч татагддаг
     байв. Хэмжилтээр `main.js` 4.49 MB болсон — router.js-ийн тайлбарт
     «lazy болгосны дараа 787 KB болсон» гэж бичсэнээс эргэж хүндэрсэн.
   ⚠ Шинэ chunk БИШ, аль хэдийн байгаа "hse" бүлэгт нийлүүлсэн —
     эвдрэх гадаргууг нэмэхгүй (router.js-ийн 3 бүлгийн зарчим).
   ⚠ `lazyRetry`-аар дамжина: chunk олдохгүй бол дахин оролдоно.
     Замын мод router.js-д Suspense + ChunkErrorBoundary дотор байгаа.  */
/* ⚠ `dashboard` нь `DashboardCharts` (@ant-design/plots) -ыг татдаг тул
     статик байхад график сан `main.js`-д орж байв. Өөрөө ХАБЭА хэлтсийн
     «биелэлтийн хяналт» хуудас — ажилтны өдөр тутмын зам БИШ. */
const KnowledgeDashboard = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/knowledge/dashboard"),
);
const KnowledgeReference = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/knowledge/reference"),
);
const KnowledgeAnalysis = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/knowledge/analysis"),
);
// ХАБЭА-гийн дүрэм журмын лавлах сан
const KnowledgeRegulations = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/knowledge/regulations"),
);
const KnowledgeAskAdmin = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/knowledge/askAdmin"),
);
const KnowledgeQrAdmin = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/knowledge/qrAdmin"),
);

const Main = () => {
  const data = [
    { path: "/knowledge/register", component: <KnowledgeRegister /> },
    { path: "/knowledge/dashboard", component: <KnowledgeDashboard /> },
    { path: "/knowledge/reference", component: <KnowledgeReference /> },
    { path: "/knowledge/analysis", component: <KnowledgeAnalysis /> },
    { path: "/knowledge/regulations", component: <KnowledgeRegulations /> },
    // Ажилтан өгүүлбэрээр/дуу хоолойгоор асууж заалт хайх
    { path: "/knowledge/ask", component: <KnowledgeAsk /> },
    // ХАБЭА-гийн хяналт — хэн юу асууж, юу олдоогүй, хариу өгөх
    { path: "/knowledge/ask-admin", component: <KnowledgeAskAdmin /> },
    // QR цэгийг удирдах (ХАБЭА хэлтэс) ба наалт хэвлэх
    { path: "/knowledge/qr-admin", component: <KnowledgeQrAdmin /> },
    // QR уншуулахад нээгдэх дэлгэц — цэсэнд байх шаардлагагүй
    { path: "/knowledge/qr/:code", component: <KnowledgeQrView /> },
    // Ажилтны хувийн хуудас — /me-ээс шилжинэ (цэсэнд байх шаардлагагүй)
    { path: "/knowledge/my", component: <KnowledgeMy /> },
  ];
  return (
    <Routes>
      {_.map(data, (el) => (
        <Route key={el.path} exact path={el.path} element={el.component} />
      ))}
    </Routes>
  );
};

export default React.memo(Main);
